<template>
  <div class="register-container" v-if="email">
    <div class="text-center">
      <h1>メール送信が完了しました。</h1>
    </div>
    <div class="announce-container">
      <span>以下のメールアドレス宛にメールをお送りしました。</span>
      <h3 class="text-red">メールに記載のパスワードからログインして下さい。</h3>
      <br>
      <span>メールアドレス</span>
      <br>
      <br>
      <p class="m-b-none">{{email}}</p>
    </div>
  </div>
</template>
<script>
export default {
  props: ['email']
}
</script>



// WEBPACK FOOTER //
// src/view/resetpassword/ConfirmEmail.vue